import React, { useEffect } from "react";
import plyr from "plyr";

interface IProps {
  source: string;
  options?: any;
  onPlay?: () => void;
  onPause?: () => void;
  onStop?: () => void;
  onEnded?: () => void;
  onUpdate?: (time: number) => void;
  startTime?: number;
  [x: string]: any;
}

export default function VideoPlayer(props: IProps) {
  const { source, options, onPlay, onPause, onStop, onEnded, startTime, onUpdate, ...other } = props;
  useEffect(() => {
    let player: any;
    let o = options
      ? options
      : {
          controls: ["play", "rewind", "current-time", "volume", "fullscreen", "settings"],
          settings: ["captions"],
        };
    const timer = setTimeout(() => {
      player = new plyr(".js-plyr", o);
      setupHandlers(player);
      if (source) {
        player.source = {
          type: "video",
          sources: [
            {
              src: source,
              provider: "vimeo",
            },
          ],
        };
      }
    }, 500);

    let updateTimer: any;
    function setupHandlers(player: any) {
      player.on("play", () => {
        if (onPlay) onPlay();
        setupUpdate();
      });
      player.on("pause", () => {
        if (onPause) onPause();
        clearTimer();
        updateTime();
      });
      player.on("stop", () => {
        if (onStop) onStop();
        clearTimer();
        updateTime();
      });
      player.on("ended", () => {
        if (onEnded) onEnded();
        clearTimer();
      });
      player.on("ready", () => {
        if (startTime && player.embed) player.embed.setCurrentTime(startTime);
        if (player.embed) player.embed.setCurrentTime(0);
      });
    }

    function setupUpdate() {
      updateTimer = setTimeout(() => {
        updateTime();
        setupUpdate();
      }, 10 * 1000);
    }

    function updateTime() {
      let currentTime = Math.floor(player.currentTime);
      onUpdate?.(currentTime);
    }

    function clearTimer() {
      if (updateTimer) clearTimeout(updateTimer);
    }

    return () => {
      if (player) player.destroy();
      if (timer) clearTimeout(timer);
      if (updateTimer) clearTimeout(updateTimer);
    };
  }, [source, options, onPlay, onPause, onStop, onEnded, startTime, onUpdate]);

  return (
    <div {...other}>
      <video data-id={source} className="js-plyr plyr" style={{ display: source ? "block" : "none" }}></video>
    </div>
  );
}
